<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage connectors</h1>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                    <button @click="handleCreateConnectorCommandV1" class="btn btn-success">Create connector</button>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div v-for="d in connectors" :key="d.ConnectorId">
                <a :href="`/#/admin/integrations/connectors/details/${d.ConnectorId}`">{{d.Name}}</a>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { guid } from '@common/Guid'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminManageConnectorsPage } from '@Integrations/Connectors/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    document.title = "Manage connectors"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useConnectorsOfOrganizationQuery, useCreateConnectorCommand } = useAdminManageConnectorsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelConnectorsOfOrganizationQueryV1, runConnectorsOfOrganizationQueryV1 } = useConnectorsOfOrganizationQuery(tid)
    const connectors = computed(() => modelConnectorsOfOrganizationQueryV1.value?.Connectors || [])

    const { invokeCreateConnectorCommandV1, succeedCreateConnectorCommandV1 } = useCreateConnectorCommand(() => guid(), tid, userId, null)

    onMounted(() => {
        runCurrentUserQueryV1()
        runConnectorsOfOrganizationQueryV1()
    })

    watch(succeedCreateConnectorCommandV1, () => runConnectorsOfOrganizationQueryV1())

    function handleCreateConnectorCommandV1() {
        const name = prompt('Enter a new connector name')
        if (name) { invokeCreateConnectorCommandV1({ Name: name }) }
    }
</script>
